import { Form, Input } from 'antd';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import './style.module.scss';

function AnswerType5({ answers, onChange, isAnswer, onSendAnswer, help }) {
  const [value, setValue] = useState([]);

  const ref = useRef()

  useEffect(() => {
    if (value.some((_i) => Boolean(_i))) {
      if(value.filter(_i => _i != '').length == answers.variants.length){
        onChange(value);
      }
    } else {
      onChange('');
    }
  }, [value]);

  useEffect(() => {
    if (answers.variants) {
      setValue(Array(answers.variants.length).fill(''));
    }
  }, [answers]);

  const onChangeInput = (v, index) => {
    const tmp = [...value];
    tmp[index] = v;
    setValue(tmp);
  };

  const onKeyDown = (index) => (e) => {

    const el = document.getElementById('ans_' + index);

    if(el){
      el.style.width = ((el.value.length + 5) * 8) +'px';
    }
  }

  const getValidateAnswer = (index) => {
    return (answers.variants[index] || '').split(',').map(_i => (_i || '').toLowerCase().trim() ).includes((value[index] || '').toLowerCase().trim())
  }

  const onKeyPress = (event) => {
    if(event.keyCode == 13 || event.key === 'Enter'){
      if(value.length){
        if(value.filter(_i => _i != '').length == answers.variants.length){
          onSendAnswer()
        }
      }
    }
  }

  const elements = [];
  answers.value.split('___').forEach((element, index) => {
    elements.push(element);
    if (answers && answers.variants && answers.variants[index]) {
      elements.push(
        <input className={classNames('inp_ans', {
          isTrue:  isAnswer && help && getValidateAnswer(index),
          isFalse:  isAnswer && help && !getValidateAnswer(index),
        })} 
        onKeyDown={onKeyDown(index)} 
        id={'ans_' + index} 
        value={isAnswer && help ? answers.variants[index].split(',')[0] : value[index]}  
        onChange={(e) => onChangeInput(e.target.value, index)}
        onKeyPress={onKeyPress}
      />
      );
    }
  });

  return <div className={'AnswerType5'}>
    {isAnswer && <div className='blockedAnswer' />}
    {elements}
  </div>;
}

export default AnswerType5;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/components/Answers/components/AnswerType5/AnswerType5.jsx